export const slider1Images = [
  {
    id: 1,
    imgUrl: `/img/GOLDEN_BRIDGE_LOGO.jpg`,
    imgAlt: `Golden Bridge`
  },
  {
    id: 2,
    imgUrl: `/img/Gourmate_copy.png`,
    imgAlt: `Gourmate`
  },
  {
    id: 3,
    imgUrl: `/img/Redmelon_Logo.png`,
    imgAlt: `Redmelon`
  },
  {
    id: 4,
    imgUrl: `/img/Golden Bridge.png`,
    imgAlt: `Golden Bridge`
  },
]


// WEBPACK FOOTER //
// ./src/components/Home/Data.js